import { useEffect } from 'react';
import { authApi } from '../services';

export const getCurrentUserPermission = async (token: string) => {
    try {
        const permissions = await authApi.getUserPermissions(token);
        authApi.setPermissions(permissions);
        return Promise.resolve();
    } catch (error) {
        console.error('Error fetching permissions:', error);
        return Promise.reject(error);
    }
};

const useFetchPermissions = () => {
    useEffect(() => {
        const token = localStorage.getItem('token');

        if (token) {
            getCurrentUserPermission(token).catch(error => {
                console.error('Permission fetch failed:', error);
            });
        }
    }, []);
};

export default useFetchPermissions;
